import React, { useEffect, useState, useContext } from "react";
import blogFetch from "../../axios/config";
import "./RegisterQuestionSector.css";
import { getIdCompany } from "../../utils/constantes";
import AsyncSelect from "react-select/async";
import Navbar from "../../layout/Navbar/Navbar";
import Sidebar from "../../layout/Sidebar/SideBar";
import ReactiveButton from "reactive-button";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import "../../styles/Style.css";

export default function RegisterQuestionSector() {
  const [selectedValue, setSelectedValue] = useState(null);
  const [checkList, setCheckList] = useState({});
  const [toggleRender, setToggleRender] = useState(false);
  const [state, setState] = useState("idle");
  

  const {
    getStatusSideBar,
    selectedCountry,
    getSector
  } = useContext(Context);

  useEffect(() => {
    getQuestions();
    getSector();
  }, []);

  useEffect(() => {
    if (selectedValue)
      getAuditSector();
  }, [selectedValue]);

  useEffect(() => {}, [checkList]);

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  // Add/Remove checked item from list
  const handleCheck = (event) => {
    let newCheckList = checkList;
    for (let i = 0; i < newCheckList.length; i++) {
      if (newCheckList[i].qeS_PK_idQuestion == event.target.value) {
        newCheckList[i].checked = event.target.checked;
        break;
      }
    }
    setCheckList(newCheckList);
    setToggleRender(!toggleRender);
  };

  const getAuditSector = async (value) => {
    try {
      let response = await blogFetch.get(
        "/auditSector/sector_/" + selectedValue.stR_PK_idSector
      );
      let data = response.data;

      let list = [];
      for (let i = 0; i < data.length; i++) {
        list.push(data[i].question.qeS_PK_idQuestion);
      }
      const newCheckList = checkList.map((item) => {
        const container = item;
        if (list.includes(item.qeS_PK_idQuestion)) {
          container["checked"] = true;
        } else {
          container["checked"] = false;
        }
        return container;
      });

      setCheckList(newCheckList);
    } catch (error) {
      console.error(error);
    }
  };
  const getQuestions = async () => {
    try {
      let response = await blogFetch.get(`/question?companyId=${getIdCompany()}`);
      let data = response.data;
      const newData = data.map((item) => {
        const container = item;
        container["checked"] = false;
        return container;
      });
      setCheckList(newData);
    } catch (error) {
      console.error(error);
    }
  };

  const addAuditSector = async () => {
    setState("loading");
    let listaAuditSector = [];
    for (let i = 0; i < checkList.length; i++) {
      if (checkList[i].checked) {
        let auditSector = {
          ADS_FK_idQuestion: checkList[i].qeS_PK_idQuestion,
          ADS_FK_idSector: selectedValue.stR_PK_idSector,
          ADS_FK_companyId: getIdCompany(),
          ADS_active: true,
        };
        listaAuditSector.push(auditSector);
      }
    }
    const response = await blogFetch.post(
      "/auditSector/lote_",
      listaAuditSector
    );
    if (response != null) {
      setState("success");
    } else {
      setState("error");
    }
    await getAuditSector();
  };

  const checkBox = () => {
    return (
      <div className="container__checkbox" id="root">
        {!!checkList &&
          Object.entries(checkList).map((eachType) => (
            <div className="form-check form-check-inline m-2 checkbox">
              <label>
                <input
                  className="form-check-input input__checkbox"
                  type="checkbox"
                  key={eachType[1].qeS_PK_idQuestion}
                  value={eachType[1].qeS_PK_idQuestion}
                  checked={eachType[1].checked}
                  disabled={selectedValue == null}
                  onChange={handleCheck}
                />
                {eachType[1].qeS_description}
              </label>
            </div>
          ))}
      </div>
    );
  };

  return (
    <>
      <Navbar />
      <Sidebar />

      <div className={`app_body ${getStatusSideBar()}`}>
        <h2 className="title_tables">
          {language[selectedCountry.name].Cadastro.perguntasSetor.title}
        </h2>
        <div className="container">
          <div className="col-md-4">
            <AsyncSelect
              cacheOptions
              defaultOptions
              placeholder="Setor"
              value={selectedValue}
              getOptionLabel={(e) => e.stR_description}
              getOptionValue={(e) => e.stR_PK_idSector}
              loadOptions={getSector}
              onChange={handleChange}
            />
          </div>
        </div>
        {toggleRender ? checkBox() : <section>{checkBox()}</section>}
        <div className="div_rounded_button">
          <ReactiveButton
            buttonState={state}
            idleText="Salvar"
            loadingText="Loading"
            successText="Ok"
            errorText="Erro"
            onClick={addAuditSector}
            className="rounded_button"
          />
        </div>
      </div>
      <footer>
        <div className="footer"></div>
      </footer>
    </>
  );
}
